import styled from 'styled-components';
import { EngineSelectStyled } from '../EngineSelectStyled';
import { rem } from 'polished';

export const EngineSelectStyledDS = styled(EngineSelectStyled)`
    .engine {
        border: solid 1px ${({ theme }) => theme.colors.grey16};
        border-radius: ${rem(8)};

        &.isSelected,
        &:hover {
            border: 1px solid ${({ theme }) => theme.colors.secondary};
            background: ${({ theme }) => theme.colors.grey4};
            .inner {
                border-radius: ${rem(5)};
                border-color: ${({ theme }) => theme.colors.secondary};
            }
        }
    }

    .engineTitle {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.black};

        .icon {
            border-color: ${({ theme }) => theme.colors.black1};

            .selected {
                width: ${rem(14)};
                height: ${rem(14)};
                top: ${rem(4)};
                left: ${rem(4)};
            }
        }
    }

    .engineDescription {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        color: ${({ theme }) => theme.colors.grey29};
    }

    .isSelected {
        border-color: ${({ theme }) => theme.colors.black1} !important;
        background-color: ${({ theme }) => theme.colors.accordionSecondaryBg};
    }
`;
